import React, { Component } from 'react';
import LinkedInIcon from '@material-ui/icons/LinkedIn'
import GitHubIcon from '@material-ui/icons/GitHub'
import TwitterIcon from '@material-ui/icons/Twitter'

class Contact extends Component {
    render() {
        return (
            <div className="col-10 mx-auto p-3 contact" id="contact">
                <div className="d-lg-flex justify-content-between justify-content-center align-items-center">
                    <p className="lead">Email: georgegithiri002@gmail.com</p>
                    <p className="lead">Phone: 0792532513</p>
                    <div className="social-Links d-flex">
                        <a href="https://twitter.com/GithiriGeorge?s=09" target="_blank" style={{color:"var(--mainBlue)"}}><span><TwitterIcon className="mx-1"/>Twitter</span></a>
                        <a href="https://www.linkedin.com/in/george-githiri-790873188" target="_blank" style={{color:"var(--mainBlue)"}}><span className="mx-4"><LinkedInIcon className="mx-1"/>LinkedIn</span></a>
                        <a href="https://github.com/GeorgeGithiri5" target="_blank" style={{color:"var(--mainBlue)"}}><span><GitHubIcon className="mx-1"/>Github</span></a>
                    </div>
                </div>
            </div>
        );
    }
}

export default Contact;